import apiRequestType from "../../../../api/apiRequestType";
import { apiTypes } from "../../../apiTypes";
import { apiConstants } from "../../../apiConstants";

const deleteDomainName = (id) => {
    return apiRequestType(apiTypes.DELETE, apiConstants.ADMIN.ORGANIZATION_SETTINGS.DELETE_DOMAIN_NAME(id))
}

export default deleteDomainName